import { render, staticRenderFns } from "./WecomePage.vue?vue&type=template&id=62c197ae&scoped=true"
import script from "./WecomePage.vue?vue&type=script&lang=js"
export * from "./WecomePage.vue?vue&type=script&lang=js"
import style0 from "./WecomePage.vue?vue&type=style&index=0&id=62c197ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c197ae",
  null
  
)

export default component.exports